import {
  BooleanParam,
  DateTimeParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { TransactionSearchOrder } from '@/globalTypes';
import {
  AdjustmentCategoryParam,
  AdjustmentTypeParam,
  PaymentStatusesParam,
  TransactionSearchOrderParam,
} from '@/utils/query/params';

export const queryParams = {
  rawId: StringParam,
  from: DateTimeParam,
  to: DateTimeParam,
  paymentStatus: PaymentStatusesParam,
  paymentMethod: StringParam,
  minAmount: NumberParam,
  maxAmount: NumberParam,
  adjustmentType: AdjustmentTypeParam,
  adjustmentCategory: AdjustmentCategoryParam,
  desc: withDefault(BooleanParam, true),
  orderBy: withDefault(
    TransactionSearchOrderParam,
    TransactionSearchOrder.processedAt,
  ),
  first: withDefault(NumberParam, 20),
  before: StringParam,
  after: StringParam,
};
